var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 10.9505L13 10.9805L12.97 4.98047C12.97 4.43047 12.52 3.98047 11.97 3.98047C11.42 3.98047 10.97 4.43047 10.97 4.98047L11 10.9805L5 11.0105C4.45 11.0105 4 11.4605 4 12.0105C4 12.5605 4.45 13.0105 5 13.0105L11 12.9805L11.03 18.9805C11.03 19.5305 11.48 19.9805 12.03 19.9805C12.58 19.9805 13.03 19.5305 13.03 18.9805L13 12.9805L19 12.9505C19.55 12.9505 20 12.5005 20 11.9505C20 11.4005 19.55 10.9505 19 10.9505Z",
  fill: "inherit"
})));
export default SvgAdd;